(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["teekop-product-benefits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('teekop-guarantee-dialog')) {
    customElements.define(
      'teekop-guarantee-dialog',
      class extends HTMLElement {
        connectedCallback() {
          const dialog = this.querySelector('dialog');
          const card = this.closest('.teekop-buy-info');
          if (!dialog || !card) return;
          let opener = null;
          let previousOverflow = '';
          // The page behind must not scroll while the panel is open; closing puts everything back.
          dialog.addEventListener('close', () => {
            document.documentElement.style.overflow = previousOverflow;
            if (opener?.isConnected) opener.focus();
            opener = null;
          });
          card.addEventListener('click', (event) => {
            const target = /** @type {Element} */ (event.target);
            const open = target.closest('[data-open-guarantee]');
            if (open && !dialog.open) {
              opener = /** @type {HTMLElement} */ (open);
              previousOverflow = document.documentElement.style.overflow;
              document.documentElement.style.overflow = 'hidden';
              dialog.showModal();
            } else if (target.closest('[data-close-guarantee]')) {
              dialog.close();
            }
          });
        }
      }
    );
  }

  if (!customElements.get('teekop-delivery-estimate')) {
    customElements.define(
      'teekop-delivery-estimate',
      class extends HTMLElement {
        connectedCallback() {
          const days = (name) => Number(this.dataset[name]);
          const processingMin = days('processingMin');
          const processingMax = days('processingMax');
          const transitMin = days('transitMin');
          const transitMax = days('transitMax');
          if (![processingMin, processingMax, transitMin, transitMax].every(Number.isFinite)) return;

          const today = new Date();
          // Saturdays and Sundays are not counted; public holidays are not known here, hence "estimated".
          const after = (businessDays) => {
            const date = new Date(today);
            for (let left = businessDays; left > 0; ) {
              date.setDate(date.getDate() + 1);
              if (date.getDay() !== 0 && date.getDay() !== 6) left -= 1;
            }
            return date;
          };
          const day = (date) => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          const range = (from, to) => {
            if (from.getTime() === to.getTime()) return day(from);
            return from.getMonth() === to.getMonth() ? `${day(from)} – ${to.getDate()}` : `${day(from)} – ${day(to)}`;
          };
          const write = (step, text) => {
            const element = this.querySelector(`[data-step="${step}"]`);
            if (element) element.textContent = text;
          };

          const delivered = range(after(processingMin + transitMin), after(processingMax + transitMax));
          const headline = this.querySelector('[data-headline]');
          if (headline) {
            headline.textContent = 'Order today, get it ';
            const dates = document.createElement('strong');
            dates.textContent = delivered;
            headline.append(dates);
          }

          write('order', day(today));
          write('ship', range(after(processingMin), after(processingMax)));
          write('deliver', delivered);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
